import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import styled from 'styled-components';
import { B400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Lozenge from '@atlaskit/lozenge';
var AsyncTooltip = /*#__PURE__*/React.lazy(function () {
  return import(
  /* webpackChunkName: "@atlaskit-internal_@atlaskit/tooltip" */
  '@atlaskit/tooltip').then(function (module) {
    return {
      default: module.default
    };
  });
});
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  line-height: 1;\n  outline: none;\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n"])));
var Text = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  color: ", ";\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n"])), token('color.text.selected', B400), function (_ref) {
  var secondary = _ref.secondary;
  return secondary && "color: ".concat(token('color.text.selected', B400), "; font-size: 0.85em;");
});
var AdditionalInfo = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  float: right;\n  ", "\n"])), function (_ref2) {
  var withTooltip = _ref2.withTooltip;
  return withTooltip && " padding-top: 5px;";
});
export var TextWrapper = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n"])), function (_ref3) {
  var color = _ref3.color;
  return color;
});
export var AvatarItemOption = function AvatarItemOption(_ref4) {
  var avatar = _ref4.avatar,
      primaryText = _ref4.primaryText,
      secondaryText = _ref4.secondaryText,
      lozenge = _ref4.lozenge,
      sourcesInfoTooltip = _ref4.sourcesInfoTooltip;
  return /*#__PURE__*/React.createElement(Wrapper, null, avatar, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '100%',
      minWidth: 0,
      flex: '1 1 100%',
      lineHeight: '1.4',
      paddingLeft: '8px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, null, primaryText), /*#__PURE__*/React.createElement(AdditionalInfo, {
    withTooltip: Boolean(sourcesInfoTooltip)
  }, !sourcesInfoTooltip && (lozenge === null || lozenge === void 0 ? void 0 : lozenge.text) && (lozenge !== null && lozenge !== void 0 && lozenge.tooltip ?
  /*#__PURE__*/
  // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
  // Lozenge text) or tooltip won't work
  React.createElement(React.Suspense, {
    fallback: /*#__PURE__*/React.createElement(Lozenge, lozenge, lozenge.text)
  }, /*#__PURE__*/React.createElement(AsyncTooltip, {
    content: lozenge.tooltip
  }, /*#__PURE__*/React.createElement(Lozenge, lozenge, lozenge.text))) : /*#__PURE__*/React.createElement(Lozenge, lozenge, lozenge.text)), sourcesInfoTooltip)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, secondaryText))));
};